import { render, staticRenderFns } from "./AdminFabbricatiView.vue?vue&type=template&id=21cc0175&"
import script from "./AdminFabbricatiView.vue?vue&type=script&lang=ts&"
export * from "./AdminFabbricatiView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports